/**
 * Indian PIN code helpers (shared by address forms + form-level validation).
 * Rule: exactly 6 digits, first digit 1-9 (no Indian PIN starts with 0).
 * Mirrors the backend's IndianPinCode validator (api/app/schemas/v1/common.py).
 */

const PIN_RE = /^[1-9]\d{5}$/;

/** Keep only digits, cap at 6. */
export function pinDigits(value: string): string {
  return value.replace(/\D/g, "").slice(0, 6);
}

/** True when `value` is a valid 6-digit Indian PIN code. */
export function isValidPinCode(value: string): boolean {
  return PIN_RE.test(pinDigits(value));
}
